import React from 'react';
import { colors } from '../../config/constants';
interface dropdownProps {
  onChange?: React.ChangeEventHandler<HTMLSelectElement> | undefined;
  value?: string | number;
  name?: string;
  type?: string;
  label?: string;
  error?: string | undefined;
  options?: { id: number | string; name: string }[];
  initialOption?: { id: number | string; name: string };
}

const Dropdown = (props: dropdownProps) => {
  const { name, label, value, onChange, options, initialOption, error } = props;
  return (
    <div className="my-1" data-testid="dropdown-wrapper">
      <div
        data-testid="dropdown-label"
        className={`${colors.primaryText} ml-1 mb-1 text-sm font-semibold`}
      >
        {label}
      </div>
      <select
        data-testid="selected-name"
        name={name}
        onChange={onChange}
        value={value}
        className={`w-full lg:w-[250px] xl:w-[300px] h-7 outline-none pl-2 text-sm border-b-2 focus:border-[#0369a1] ${
          error === undefined ? '' : 'border-[red]'
        } placeholder-[#808080]`}
      >
        <option className="text-[#808080]" value={initialOption?.id}>
          {initialOption?.name}
        </option>
        {options && (
          <>
            {options.length > 0 && (
              <>
                {options?.map(
                  (option: { id: number | string; name: string }, index: number) => {
                    return (
                      <option
                        data-testid="dropdown-values"
                        key={index}
                        value={option.id}
                      >
                        {option.name}
                      </option>
                    );
                  }
                )}
              </>
            )}
          </>
        )}
      </select>
      {error ? <div className="text-sm text-[red] ml-2 mt-1">{error}</div> : null}
    </div>
  );
};

export default Dropdown;
